import React from 'react';
import { TrendingUp, Star, Sparkles, Zap, Megaphone } from 'lucide-react';
import './CampTag.css';

interface CampTagProps {
  text: string;
  variant?: 'popular' | 'rated' | 'instant_booking' | 'new' | 'promoted' | 'default';
}

const CampTag: React.FC<CampTagProps> = ({ text, variant = 'default' }) => {
  const getIcon = () => {
    switch (variant) {
      case 'popular':
        return <Star className="camp-tag-icon" size={14} />;
      case 'rated':
        return <Star className="camp-tag-icon" size={14} />;
      case 'instant_booking':
        return <Zap className="camp-tag-icon" size={14} />;
      case 'new':
        return <Sparkles className="camp-tag-icon" size={14} />;
      case 'promoted':
        return <Megaphone className="camp-tag-icon" size={14} />;             
      default:
        return <TrendingUp className="camp-tag-icon" size={14} />;
    }
  };

  return (
    <div className={`camp-tag camp-tag--${variant}`}>
      {getIcon()}
      <span className="camp-tag-text">{text}</span>
    </div>
  );
};

export default CampTag;
